import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import pprint from "../Utils/pprint";
import {
    IConsultationCommunicationType,
    IConsultationConfig,
    IConsultationDuration,
    IConsultationLanguage,
    IConsultationType
} from "../Types/psychology/consultation";
import {IPsychologistSkillCategory, IPsychologistSpecialization} from "../Types/psychology/psychologist";
import {axios} from "Auth/axiosConfig";

interface PsychologyParamsState {
    durations: IConsultationDuration[];
    consultation_types: IConsultationType[];
    languages: IConsultationLanguage[];
    communication_types: IConsultationCommunicationType[];
    skill_categories: IPsychologistSkillCategory[];
    specializations: IPsychologistSpecialization[];
    consultation_configs: IConsultationConfig[]; // Added this line
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

// Initial state
const initialState: PsychologyParamsState = {
    durations: [],
    consultation_types: [],
    languages: [],
    communication_types: [],
    skill_categories: [],
    specializations: [],
    consultation_configs: [],
    status: 'idle',
    error: null,
};

// Async thunk to fetch all parameters
export const fetchPsychologyParams = createAsyncThunk(
    'psychologyParams/fetchAll',
    async () => {
        const response = await axios.get('/api/v1/psychology/params/');
        pprint('Psychology params fetched: ', response.data);
        return response.data;
    }
);

const psychologyParamsSlice = createSlice({
    name: 'psychologyParams',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPsychologyParams.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPsychologyParams.fulfilled, (state, action: PayloadAction<any>) => {
                state.status = 'succeeded';
                state.durations = action.payload.durations;
                state.consultation_types = action.payload.consultation_types;
                state.languages = action.payload.languages;
                state.skill_categories = action.payload.skill_categories;
                state.specializations = action.payload.specializations;
                state.consultation_configs = action.payload.consultation_configs; // Added this line
            })
            .addCase(fetchPsychologyParams.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'Failed to fetch parameters';
            });
    },
});

export default psychologyParamsSlice.reducer;
